import { inject, InjectionKey } from 'vue';

// What a routed Vue view needs from the Angular host (its $location, in-memory services), wired in VueRouterWrapper
export interface AngularBridge {
    navigate(url: string, replace?: boolean): void;
    createTemplate(): void;
    editTemplate(templateId: string): void;
}

export const ANGULAR_BRIDGE: InjectionKey<AngularBridge> = Symbol('AngularBridge');

export const useAngularBridge = (): AngularBridge => {
    const bridge = inject(ANGULAR_BRIDGE);
    if (!bridge) throw new Error('useAngularBridge must be used inside VueRouterWrapper');

    return bridge;
};
